import DocumentFolderInput from "components/DocumentFolderInput";
import { useMemo } from "react";
import {
	AnalysisEventDocument,
	AnalysisEventDocumentFolder,
	FileExtensionData
} from "services/types";
import { sortDocumentFoldersByRootFolder } from "utils/documents";
import EmptyAttachmentsContent from "./EmptyAttachmentsContent";
import EventDocumentList from "./EventDocumentList";

export default function AnalysisEventDocumentDisplay({
	assortedDocuments,
	documentFolders,
	fileExtensions
}: Readonly<{
	assortedDocuments: AnalysisEventDocument[];
	documentFolders: AnalysisEventDocumentFolder[];
	fileExtensions: FileExtensionData[];
}>): JSX.Element {
	const documentCount = assortedDocuments.length + documentFolders.length;
	if (documentCount === 0) return <EmptyAttachmentsContent />;

	const documentFoldersByRootFolder = useMemo(() => {
		return sortDocumentFoldersByRootFolder(documentFolders, false) as {
			folders: AnalysisEventDocumentFolder[];
			label: string;
		}[];
	}, [documentFolders]);

	return (
		<div className="flex flex-col w-full h-full">
			{!!assortedDocuments.length && (
				<div className="flex flex-col w-full pb-6 md:gap-3">
					<h3 className="text-base font-semibold h-[4.5rem] md:h-fit flex items-center">
						Anexos avulsos
					</h3>
					<EventDocumentList
						eventDocuments={assortedDocuments}
						allowExpansion={documentFolders.length > 0}
					/>
				</div>
			)}
			{!!documentFolders.length && (
				<div className="flex flex-col w-full pb-6 md:gap-3">
					<h3 className="text-base font-semibold h-[4.5rem] md:h-fit flex items-center">
						Documentos em pasta
					</h3>
					<div className="flex flex-col w-full gap-6">
						{documentFoldersByRootFolder.map((rootFolder, rootFolderIndex) => {
							if (rootFolder.folders.length === 0)
								return <div key={`rootFolder-${rootFolderIndex}`} />;
							return (
								<div
									key={`rootFolder-${rootFolderIndex}`}
									className="flex flex-col gap-3"
								>
									<div className="text-transform--uppercase text-sm text-caption-default">
										{rootFolder.label}
									</div>
									{rootFolder.folders.map((documentFolder) => (
										<DocumentFolderInput
											key={documentFolder.folderTypeData.id}
											readonly
											folderName={
												documentFolder.folderTypeData.documentType.name
											}
											folderType={documentFolder.folderTypeData.id}
											value={documentFolder}
											fileExtensions={fileExtensions}
											initiallyExpanded={false}
										/>
									))}
								</div>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);
}
